/**
 * API for loading and saving sources via the code.org dashboard, which saves to S3.
 * A source is the code of a project.
 */

import HttpClient, {
  GetResponse,
  ResponseValidator,
} from '@cdo/apps/util/HttpClient';

import {SOURCE_FILE} from '../constants';
import {ProjectSources, ProjectVersion, SaveSourceOptions} from '../types';

const {stringifyQueryParams} = require('@cdo/apps/utils');

const rootUrl = (channelId: string) =>
  `/v3/sources/${channelId}/${SOURCE_FILE}`;

export async function get(
  channelId: string,
  validator: ResponseValidator<ProjectSources>,
  versionId?: string
): Promise<GetResponse<ProjectSources>> {
  let url = rootUrl(channelId);
  if (versionId) {
    url += `?version=${versionId}`;
  }
  return HttpClient.fetchJson<ProjectSources>(url, {}, validator);
}

export async function update(
  channelId: string,
  sources: ProjectSources,
  options?: SaveSourceOptions
): Promise<Response> {
  const url = rootUrl(channelId) + stringifyQueryParams(options);
  return fetch(url, {
    method: 'PUT',
    body: JSON.stringify(sources),
  });
}

export async function getVersionList(
  channelId: string,
  includeComments: boolean = false
): Promise<GetResponse<ProjectVersion[]>> {
  let requestUrl = rootUrl(channelId) + '/versions';
  if (includeComments) {
    requestUrl += '?with_comments=true';
  }
  return HttpClient.fetchJson<ProjectVersion[]>(requestUrl);
}

export async function restore(channelId: string, versionId: string) {
  const url = rootUrl(channelId) + `/restore?version=${versionId}`;
  return HttpClient.put(url);
}
